export class leg {
  Auto: any;
  Runners: string | string[];

  constructor(Auto: any, Runners: string | string[]) {
    this.Auto = Auto;
    this.Runners = Runners;
  }

  toString(): string {
    let legString = '';
    const RunnersList = this.getRunnerArray();
    let cont = 0;

    for (let i = 0; i < RunnersList.length; i++) {
      while (parseInt(RunnersList[i + cont]) + 1 === parseInt(RunnersList[i + cont + 1])) {
        cont++;
      }

      if (cont > 1) {
        legString += ',' + RunnersList[i] + '-' + RunnersList[i + cont];
      }
      else {
        for (let intc = 0; intc <= cont; intc++) {
          legString += ',' + RunnersList[i + intc];
        }
      }

      i += cont;
      cont = 0;
    }

    return legString.substring(1);
  }

  getRunnerArray(): string[] {
    return typeof this.Runners === 'string' ? this.Runners.split(',') : this.Runners;
  }
}
